import { ImageWithPlaceholder } from '@wbk/ui';

type Props =
  | ({
      type: 'image';
    } & React.ImgHTMLAttributes<HTMLImageElement>)
  | ({
      type: 'video';
    } & React.VideoHTMLAttributes<HTMLVideoElement>);

const ImageOrVideo = ({ src, ...rest }: Props) => {
  if (rest.type === 'image') {
    return <ImageWithPlaceholder src={src} {...rest} />;
  }

  return <video src={src} autoPlay muted loop playsInline {...rest} />;
};

export default ImageOrVideo;
